import {Routes, RouterModule} from '@angular/router';
import {ProfileComponent} from './profile.component';
import {AuthGuard} from '../guards/loggedin.guard';
const routes: Routes = [
  {
    path: 'profile',
    canActivate: [AuthGuard],
    component : ProfileComponent
  }];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/profile/profile.routing.ts